// =====================================================================
// ICDocument primitives — small shared bits used by ICDocument.jsx + sections.
// Extracted (iter-35e) to keep the parent shell focused on layout.
// =====================================================================

const STRIPE_COLORS = ["#FFCC00", "#FF69B4", "#20B2AA", "#FFA500", "#9370DB"];

export function ColorStripe() {
  return (
    <div className="flex h-1.5 w-full">
      {STRIPE_COLORS.map((c) => (
        <div key={c} className="flex-1" style={{ background: c }} />
      ))}
    </div>
  );
}

export function MetaRow({ label, value }) {
  return (
    <div className="flex flex-col gap-1">
      <div className="text-[9px] font-bold uppercase tracking-wider text-zinc-500">{label}</div>
      <div
        className="text-[12px] font-semibold text-zinc-900 overflow-hidden"
        style={{ lineHeight: 1.5, paddingBottom: 2, textOverflow: "ellipsis", whiteSpace: "nowrap" }}
        title={value}
      >
        {value || "—"}
      </div>
    </div>
  );
}

export function SectionTitle({ accent, children }) {
  return (
    <div className="flex items-center gap-2 mt-4 mb-2">
      <span className="block w-1 h-4 rounded-sm" style={{ background: accent }} />
      <h3 className="text-[11px] font-black uppercase tracking-wider text-zinc-900">{children}</h3>
    </div>
  );
}
